export default "__VITE_ASSET__Dxr5DyY3__"